import { render } from "./JumpLinkCourse.vue?vue&type=template&id=f019cc0a&scoped=true"
import script from "./JumpLinkCourse.vue?vue&type=script&lang=js"
export * from "./JumpLinkCourse.vue?vue&type=script&lang=js"

import "./JumpLinkCourse.vue?vue&type=style&index=0&id=f019cc0a&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f019cc0a"]])

export default __exports__